/**
 * 필터 바 컴포넌트
 */

import React, { useState } from 'react';
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import './FilterBar.css';

export interface FilterField {
  name: string;
  label: string;
  type: 'text' | 'select' | 'date' | 'dateRange';
  options?: { value: string; label: string }[];
  placeholder?: string;
}

interface FilterBarProps {
  fields: FilterField[];
  values: Record<string, any>;
  onChange: (values: Record<string, any>) => void;
  onReset?: () => void;
  onSearch?: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  fields,
  values,
  onChange,
  onReset,
  onSearch,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (name: string, value: any) => {
    onChange({
      ...values,
      [name]: value,
    });
  };

  const handleReset = () => {
    const resetValues: Record<string, any> = {};
    fields.forEach((field) => {
      resetValues[field.name] = '';
    });
    onChange(resetValues);
    onReset?.();
  };

  return (
    <div className="filter-bar">
      <Row className="align-items-center">
        <Col md={12}>
          <div className="filter-bar-header">
            <Button
              variant="link"
              className="filter-toggle-btn"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? '필터 숨기기 ▲' : '필터 보기 ▼'}
            </Button>
            <div className="filter-actions">
              {onSearch && (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={onSearch}
                  className="me-2"
                >
                  검색
                </Button>
              )}
              {onReset && (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleReset}
                >
                  초기화
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      {expanded && (
        <Row className="mt-3">
          {fields.map((field) => (
            <Col key={field.name} md={field.type === 'dateRange' ? 6 : 3} className="mb-3">
              <Form.Label className="filter-label">{field.label}</Form.Label>
              {field.type === 'text' && (
                <Form.Control
                  type="text"
                  placeholder={field.placeholder || field.label}
                  value={values[field.name] || ''}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
              )}
              {field.type === 'select' && (
                <Form.Select
                  value={values[field.name] || ''}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                >
                  <option value="">전체</option>
                  {field.options?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              )}
              {field.type === 'date' && (
                <Form.Control
                  type="date"
                  value={values[field.name] || ''}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
              )}
              {field.type === 'dateRange' && (
                <InputGroup>
                  <Form.Control
                    type="date"
                    placeholder="시작일"
                    value={values[`${field.name}_from`] || ''}
                    onChange={(e) => handleChange(`${field.name}_from`, e.target.value)}
                  />
                  <InputGroup.Text>~</InputGroup.Text>
                  <Form.Control
                    type="date"
                    placeholder="종료일"
                    value={values[`${field.name}_to`] || ''}
                    onChange={(e) => handleChange(`${field.name}_to`, e.target.value)}
                  />
                </InputGroup>
              )}
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default FilterBar;

